import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { registerTranslationsManuallyStatic } from '@skyeng/libs/shared/i18n';
import { ThreadStatus } from '../../const';
import { Thread } from '../../interface';
import { LastNUniqAuthorsPipe } from '../../pipe/last-n-uniq-els';
import { CommunicationLikeDirective } from '../communication-like/communication-like.directive';
import { CommunicationsMessageComponent } from '../communication-message/communication-message';
import { DsLinkModule } from '@skyeng/libs/shared/ui-kit-v2/link';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';
import { VimCoreUserModule } from '@skyeng/libs/vimbox-core/user';
import entranslation from '../../translation/en.json';
import rutranslation from '../../translation/ru.json';

@Component({
  selector: 'skypro-communication-thread',
  templateUrl: 'communication-thread.html',
  styleUrls: ['communication-thread.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommunicationsMessageComponent,
    CommunicationLikeDirective,
    DsLinkModule,
    VimCoreUserModule,
    DsIconModule,
    TranslocoModule,
    LastNUniqAuthorsPipe,
  ],
})
export class CommunicationsThreadComponent {
  @Input() thread: Thread;
  @Input() isHighlighted = false;
  @Input() isExpandedMessages = false;
  @Input() readOnly = false;

  @Input() canEdit = false;
  @Input() canDelete = false;

  @Input() canClose = false;
  @Input() canPin = false;
  @Input() canHide = false;

  @Input() hasActions = true;

  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() selectedThreadIdChange = new EventEmitter<void>();
  @Output() unselectedThreadIdChange = new EventEmitter<void>();
  @Output() replyClicked = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  @Output() pin = new EventEmitter<void>();
  @Output() unpin = new EventEmitter<void>();
  @Output() hide = new EventEmitter<void>();
  @Output() show = new EventEmitter<void>();

  ThreadStatus = ThreadStatus;

  private translocoService = inject(TranslocoService);

  constructor() {
    registerTranslationsManuallyStatic('skyproCommunications', this.translocoService, {
      en: entranslation,
      ru: rutranslation,
    });
  }

  toggleSelect(): void {
    if (this.isExpandedMessages) {
      this.unselectedThreadIdChange.emit();
    } else {
      this.selectedThreadIdChange.emit();
    }
  }
}
